import { render, staticRenderFns } from "./CodeStructure.vue?vue&type=template&id=4ed73b67&"
import script from "./CodeStructure.vue?vue&type=script&lang=js&"
export * from "./CodeStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports